<template>
	<div>
		<v-flex class="d-flex align-center pa-0 mb-2" v-if="$vuetify.breakpoint.smAndDown">
			<h5 class="text-h5 primary--text text--lighten-5">Game Review</h5>
		</v-flex>

		<v-sheet dark class="mx-auto surfaceDark darken-2 darken-2" max-width="100%">
			<v-slide-group center-active v-model="model" class="pa-2" mobile-breakpoint="1000">
				<v-slide-item v-for="(game, i) in muayThaiReviews" :key="i" v-slot="{ toggle }">
					<v-card class="ma-2" :width="$vuetify.breakpoint.smAndDown ? '230' : '330'" @click="toggle">
						<v-img :height="$vuetify.breakpoint.smAndDown ? '300' : '420'" transition="scroll-y-transition" :src="game.src"></v-img>
					</v-card>
				</v-slide-item>
			</v-slide-group>
		</v-sheet>
	</div>
</template>

<script>
export default {
	data() {
		return {
			model: null,
		}
	},
	computed: {
		muayThaiReviews() {
			return this.$store.getters["Casino/muayThaiReviews"]
		},
	},
}
</script>

<style lang="sass" scoped>
.v-card
	transition: .1s ease-in-out
	opacity: 0.7
	&:hover
		filter: saturate(110%)
		transform: translateY(-0.5rem)
		opacity: 1
</style>
